/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

type Meta = {
  content: string;
  name: string;
};

type Props = {
  bodyClass?: string;
  description?: string;
  facebook: string;
  lang?: string;
  meta: Meta[];
  slug: string;
  title: string;
  twitter: string;
};

function SEO({ bodyClass, description, facebook, meta, slug, title, twitter }: Props) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;

  return (
    <Helmet
      bodyAttributes={{
        class: bodyClass,
      }}
      htmlAttributes={{
        lang: 'fr',
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : undefined}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: `https://www.mangerbouger.fr/recettes-en-2-2${facebook}`,
        },
        {
          property: `og:url`,
          content: `https://www.mangerbouger.fr/recettes-en-2-2${slug}`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: `@santeprevention`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `twitter:image`,
          content: `https://www.mangerbouger.fr/recettes-en-2-2${twitter}`,
        },
      ].concat(meta)}
      script={[
        {
          type: 'text/javascript',
          innerHTML:
            'var tc_vars = { "env_work" : "static", "user_id" : "", "user_cat" : "", "pagename" : document.title, "S1" : "14", "S2" : "", "S3" : "", "S4" : "", "search_keywords" : "", "search_page_number" : "", "search_results_number" : "" };',
        },
        {
          src: '//cdn.tagcommander.com/2251/tc_recettes22_6.js',
          type: 'text/javascript',
        },
      ]}
    ></Helmet>
  );
}

SEO.defaultProps = {
  lang: `fr`,
  meta: [],
  description: ``,
};

export default SEO;
